import React from 'react';

const UserTableRow = ({ children }) => (
  <tr>
    <td>
      {children}
    </td>
  </tr>
);

export default UserTableRow;
